import Jobs from '../../data/jobs'


const state = {
	jobs : Jobs.jobs
}


const getters = {

}


const mutations = {
};


const actions = {
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}